import { useEffect, useState } from "react";

/**
 * Hook to detect mobile viewport and orientation
 */
export function useMobile() {
	const [isMobile, setIsMobile] = useState(false);
	const [isTablet, setIsTablet] = useState(false);
	const [isLandscape, setIsLandscape] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			const width = window.innerWidth;
			const isMobileWidth = width < 768; // md breakpoint
			const isTabletWidth = width >= 768 && width < 1024; // lg breakpoint
			setIsMobile(isMobileWidth);
			setIsTablet(isTabletWidth);
			setIsLandscape(window.innerHeight < window.innerWidth);
		};

		checkMobile();
		window.addEventListener("resize", checkMobile);
		window.addEventListener("orientationchange", checkMobile);

		return () => {
			window.removeEventListener("resize", checkMobile);
			window.removeEventListener("orientationchange", checkMobile);
		};
	}, []);

	return { isMobile, isTablet, isLandscape };
}
